import {Injectable} from '@angular/core';
import {Autowired} from '@angular-ru/autowired';
import {WebUtilities} from '@app/core/utilities/web.utilities';
import {Observable, of} from 'rxjs';
import {IRecuperationListeDonneesRequete} from '@app/core/interfaces/actions/i-recuperation-liste-donnees-requete';
import {SgiRestService} from '@app/core/services/sgi/sgi-rest.service';
import {API_RECUPERER_ACTES_DEMANDE_PEC} from '@app/core/constantes';
import {DatePipe} from '@angular/common';
import {IUserConnect} from '@app/core/interfaces/user/i-user-connect';
import {SecurityStateService} from '@app/core/states/security/security.state.service';

@Injectable({providedIn: 'root'})
export class ActeSoinAutocompleteFormRestApiService extends SecurityStateService implements IRecuperationListeDonneesRequete {
  @Autowired() restService: SgiRestService;
  @Autowired() datePipe: DatePipe;

  storageUser: IUserConnect = this.getUser();

  postArgsMute = {successMute: true, errorMute: false, headers: null, params: null};

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    const { adherant, autocomplete } = args;

    if (autocomplete.acte === '') {
      const body = {items: []};
      return of({body: body});
    }

    const sendData = {...data,
      itemToSearch: {
        estActive: true,
        estHospitalisation: false,
        idPrestataire: JSON.parse(window.sessionStorage.getItem('currentUser')).personne.idPrestataireMedical,
        idSouscriptionLigne: adherant.idSouscriptionLigne,
        libelle: autocomplete.acte,

        InfoSearchdatePrestation: { Consider: true },
        InfoSearchestActive: { Consider: true },
        InfoSearchestHospitalisation: { Consider: true },
        InfoSearchidPrestataire: { Consider: true },
        InfoSearchidSouscriptionLigne: { Consider: true },
        InfoSearchlibelle: { Consider: true, IsOrderByField: true },
      },
      TakeAll: false,
    };
    // tslint:disable-next-line:max-line-length
    return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_RECUPERER_ACTES_DEMANDE_PEC}`, sendData, {...this.postArgsMute});
  }

}
